<template>
    <content-loader
        :width="375"
        :height="688"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
    >
        <rect x="15" y="1" rx="0" ry="0" width="350" height="113" />
        <rect x="16" y="120" rx="0" ry="0" width="170" height="300" />
        <rect x="194" y="120" rx="0" ry="0" width="170" height="200" />
        <rect x="16" y="425" rx="0" ry="0" width="170" height="180" />
        <rect x="194" y="325" rx="0" ry="0" width="170" height="180" />
        <rect x="16" y="610" rx="0" ry="0" width="170" height="170" />
        <rect x="194" y="510" rx="0" ry="0" width="170" height="200" />
        <rect x="16" y="785" rx="0" ry="0" width="170" height="170" />
    </content-loader>
</template>

<script>
    import { ContentLoader } from "vue-content-loader"

    export default {
        components: { ContentLoader }
    }
</script>



// WEBPACK FOOTER //
// src/skeleton/loveMarketSkeleton.vue